/**
 * Lifted whiteboard panel state — Phase 1B-I follow-up.
 *
 * OperatorToolbar used to keep `wbOpen` in local React state. The
 * embed-iframe host bridge needs to flip it from outside the component
 * tree (a `widget.openWhiteboard()` postMessage from the host), so the
 * state lives in a zustand store both surfaces read.
 *
 * Used by:
 *   • OperatorToolbar — reads `open`; toggles via `setOpen` from the
 *     toolbar's Whiteboard button.
 *   • EmbedRoomCommands — flips `open` from inbound `open-whiteboard`
 *     / `close-whiteboard` host commands.
 */
import { create } from "zustand";

type Store = {
  open: boolean;
  setOpen: (v: boolean) => void;
};

export const useWhiteboardPanelStore = create<Store>((set) => ({
  open: false,
  setOpen: (v) => set({ open: v }),
}));
